import styled from 'styled-components';

export const UserHomeBackground = styled.div`
  padding: 50px 50px 120px;
  height: auto;
  min-height: 100%;
  align-items: center;
  background: ${({ theme }) => theme.background};
`;
